import { ArgumentError } from '../utils/errors';
import ImageUploadConfigModel from './imageUploadConfig';
import { fetcher } from '@weezevent/weezjs-core';

export default class UploadRequestConfigModel extends ImageUploadConfigModel {
    static PROCESS = 'attendee-import';

    uploadConfig({ organizationId, eventId, datas = {}, name = '' }) {
        let url = `/ticket/organizations/${organizationId}/events/${eventId}/orders/import/config`;
        if (name) {
            url += `?name=${name}`;
        }
        return fetcher.post(url).then(({ response }) => {
            this.upload_config = response;
            this.data = datas;
            return this;
        });
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][UploadRequest][getAll] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/import`;
    }
}
